import React from 'react'

import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import DatenschutzSeite from '../components/datenschuetz'
import Footer from '../components/footer'
import './datenschutz.css'

const Datenschutz = (props) => {
  return (
    <div className="datenschutz-container">
      <Helmet>
        <title>Datenschutz</title>
        <meta
          property="og:title"
          content="Datenschutz - All Obedient Rhinoceros"
        />
        <link
          rel="canonical"
          href="https://all-obedient-rhinoceros-5cbetl.teleporthq.app/datenschutz"
        />
      </Helmet>
      <Navigation rootClassName="navigationroot-class-name1"></Navigation>
      <DatenschutzSeite rootClassName="textroot-class-name1"></DatenschutzSeite>
      <Footer rootClassName="footerroot-class-name1"></Footer>
    </div>
  )
}

export default Datenschutz
